export const isValidUrl = (value: string): boolean => {
  if (!value?.trim()) return false;

  const hostOrigin = window.location.origin;

  try {
    const url = new URL(value);
    // Check if the URL starts with http:// or https:// to avoid XSS attacks
    if (!['http:', 'https:'].includes(url.protocol)) {
      return false;
    }

    if (url.origin === hostOrigin) {
      return true;
    }

    // Regular expression to match UserWay domains and subdomains
    const domainRegex =
      /^(https:\/\/)(?:qa\.|api\.qa\.|api\.dev\.|cdn\.dev\.|cdn\.qa\.|cdn77\.api\.qa\.|manage\.qa\.|manage\.dev\.|api\.|cdn\.|cdn77\.api\.|manage\.|)?userway\.(org|dev)(\/api\/|\/)?/;

    // Verify if the URL's domain matches the UserWay pattern or is the host site's origin
    return domainRegex.test(url.href);
  } catch (_) {
    return false;
  }
};
